import { SubmitButton } from "@imago/api-client-for-react"
import { AppointmentView, BookingDialog, useBookService } from "../../Book.tsx"
import { useService, useServiceAppointment } from "../../../api.ts"
import { GAHTSetupCall_ID, GAHTTransferCall_ID } from "@imago/model"

function BookACall() {
	const bookSetup = useBookService({serviceID: GAHTSetupCall_ID})
	const bookTransfer = useBookService({serviceID: GAHTTransferCall_ID})

	return <>
		<form>
			<SubmitButton mutation={bookSetup} vars={data => {}}>I want to start GAHT</SubmitButton>
			<SubmitButton mutation={bookTransfer} vars={data => {}}>I’m already on GAHT, I want to move to Imago</SubmitButton>
		</form>
		<BookingDialog mutation={bookSetup}/>
		<BookingDialog mutation={bookTransfer}/>
	</>
}

export function useGAHTSetupAppointment() {
	const setupAppointment = useServiceAppointment(GAHTSetupCall_ID)
	const transferAppointment = useServiceAppointment(GAHTTransferCall_ID)
	const appointment = (setupAppointment === undefined || transferAppointment === undefined) ? undefined : (setupAppointment ?? transferAppointment)
	return appointment
}

export function TalkWithAPhysician({allowed}: {allowed: boolean}) {
	const appointment = useGAHTSetupAppointment()
	const service = useService(appointment?.serviceID)

	return <section>
		<h2>Talk with our physician</h2>
		<p>Our physician will tell you everything you need to know about the Gender-Affirming Hormone Therapy, and will answer your questions. They’ll also review your medical history and blood tests, to ensure that the therapy is safe and efficient.</p>
		{appointment ? <>
			<AppointmentView appointment={appointment} service={service} showTips={true}/>
		</> : allowed ? <>
			<BookACall/>
		</> : <p><strong>To book a call - please finish the above steps first.</strong></p>}
	</section>
}
